"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/** eslint-disable @typescript-eslint/restrict-plus-operands */
/* eslint-disable react/jsx-fragments */
const moment_1 = __importDefault(require("moment"));
const react_1 = __importDefault(require("react"));
const employee_card_v2_1 = require("@app/component/modals/employee-card-v2/employee-card-v2");
const offers_1 = require("@app/component/modals/offers");
const shift_1 = require("@app/component/modals/shift-1.5/shift");
const unavailability_modal_1 = require("@app/component/modals/unavailability-1.5/unavailability-modal");
const const_1 = require("@app/const");
const graphql_1 = require("@app/gql-types/graphql");
const util_1 = require("@app/util");
const format_hours_1 = require("@app/util/format-hours");
const maybe_1 = require("@app/util/functional/maybe");
const use_workspace_unavailability_categories_1 = require("@app/util/hooks/use-workspace-unavailability-categories");
const use_modal_hoc_1 = require("@app/util/modal/use-modal-hoc");
const _ui_1 = require("@ui");
const event_1 = __importDefault(require("../event"));
require("../section/index.scss");
const sort_by_1 = require("../sort-by");
const balancing_period_contract_minutes_cell_1 = require("./components/balancing-period-contract-minutes-cell");
const balancing_period_planned_minutes_cell_1 = require("./components/balancing-period-planned-minutes-cell");
const contract_start_end_1 = require("./components/contract-start-end");
const month_contract_minutes_cell_1 = require("./components/month-contract-minutes-cell");
const month_planned_minutes_cell_1 = require("./components/month-planned-minutes-cell");
const no_known_value_1 = require("./components/no-known-value");
const connect_1 = __importDefault(require("./connect"));
function isDateInThePast(date) {
    if (date === null) {
        return false;
    }
    if (date === undefined) {
        return false;
    }
    return (0, util_1.cachedMoment)(date).isBefore((0, moment_1.default)());
}
class Row extends react_1.default.Component {
    getRowHTML;
    getTooltipContent;
    ref;
    calendarView;
    constructor(props) {
        super(props);
        this.getRowHTML = this._getRowHTML.bind(this);
        this.getTooltipContent = this._getTooltipContent.bind(this);
        this.ref = react_1.default.createRef();
        this.calendarView = props.calendar?.view ?? 'month';
    }
    shouldComponentUpdate(nextProps) {
        const { props } = this;
        // update if the row started being visible
        if (props.notVisible !== nextProps.notVisible && !nextProps.notVisible) {
            return true;
        }
        // update if computed row height changes (significantly)
        if (Math.abs((props.computedRowHeight ?? 0) - nextProps.computedRowHeight) >= 5) {
            return true;
        }
        // A row only draws content while it's visible; an off-screen row renders a placeholder that
        // reads no calendar field. So instead of re-rendering every row on any calendar change (which
        // during loading churns constantly via loadedPeriods/roleStats/changedShiftsCount), we compare
        // only the specific calendar fields this row actually displays, and only while it's visible.
        if (!nextProps.notVisible) {
            // cache frequently accessed objects to reduce property lookups
            const currentCalendar = props.calendar;
            const nextCalendar = nextProps.calendar;
            const currentRow = props.row;
            const nextRow = nextProps.row;
            // update if calendar's date is changed (primitive comparison - fast)
            if (currentCalendar?.date !== nextCalendar?.date) {
                return true;
            }
            // update if calendar's view changed (day/week/month changes the whole row layout)
            if (currentCalendar?.view !== nextCalendar?.view) {
                return true;
            }
            // update if calendar's contextMenuForColumn changed (reference compare - it's set via
            // setCalendar, which only produces a new object on real changes)
            if (currentCalendar?.contextMenuForColumn !== nextCalendar?.contextMenuForColumn) {
                const currentEmployee = currentRow.employee;
                if ((currentCalendar?.contextMenuForColumn &&
                    currentCalendar.contextMenuForColumn.rowEmployee === currentEmployee) ||
                    (nextCalendar?.contextMenuForColumn &&
                        nextCalendar.contextMenuForColumn.rowEmployee === currentEmployee)) {
                    return true;
                }
            }
            // update if we selected/unselected some multiselect day target in this row
            if (nextProps.calendarMultiSelect) {
                const currentMultiSelect = props.calendarMultiSelect;
                const nextMultiSelect = nextProps.calendarMultiSelect;
                const nextEmployee = nextRow.employee;
                const currentEmployee = currentRow.employee;
                if (nextMultiSelect?.targets?.some((t) => t.userId === nextEmployee)) {
                    return true;
                }
                if (currentMultiSelect?.targets?.some((t) => t.userId === currentEmployee)) {
                    return true;
                }
                if (currentMultiSelect?.isSelectingTargets !==
                    nextMultiSelect?.isSelectingTargets) {
                    return true;
                }
            }
            // update if we have context menu for column open and events start or end being added
            if (nextCalendar?.contextMenuForColumn) {
                if (nextProps.isCreatingShiftFromContextMenu !==
                    props.isCreatingShiftFromContextMenu) {
                    return true;
                }
                if (nextProps.isCreatingEventsFromMultiSelect !==
                    props.isCreatingEventsFromMultiSelect) {
                    return true;
                }
            }
            // update if props.day changed (primitive comparison)
            if (props.day !== nextProps.day) {
                return true;
            }
            // update if relevant part of the calendar.roleStats changes
            const currentRoleStats = currentRow.labelData.user &&
                currentCalendar?.roleStats &&
                currentCalendar.roleStats[currentRow.labelData.user.id];
            const nextRoleStats = nextRow.labelData.user &&
                nextCalendar?.roleStats &&
                nextCalendar.roleStats[nextRow.labelData.user.id];
            if (currentRoleStats !== nextRoleStats) {
                return true;
            }
            // update if this row's vacations stats change (keyed by employee, like roleStats above)
            const currentVacations = currentCalendar?.vacations && currentCalendar.vacations[currentRow.employee];
            const nextVacations = nextCalendar?.vacations && nextCalendar.vacations[nextRow.employee];
            if (currentVacations !== nextVacations) {
                return true;
            }
            // update if this row changes - events comparison
            const currentEvents = currentRow.events;
            const nextEvents = nextRow.events;
            if (currentEvents.length !== nextEvents.length)
                return true;
            for (let i = 0; i < currentEvents.length; i++) {
                if (currentEvents[i].length !== nextEvents[i].length) {
                    return true;
                }
                for (let j = 0; j < currentEvents[i].length; j++) {
                    if (util_1.miscUtil.hasEventChanged(currentEvents[i][j], nextEvents[i][j])) {
                        return true;
                    }
                }
            }
            // row label data comparison - try primitive first, then stringify
            if (currentRow.labelData.title !== nextRow.labelData.title) {
                return true;
            }
            if (util_1.miscUtil.safeStringify(currentRow.labelData.user) !==
                util_1.miscUtil.safeStringify(nextRow.labelData.user)) {
                return true;
            }
            // update if number of closed days changes
            // cache filter results to avoid double computation
            const currentClosedCount = props.workspaceEvents.filter((ev) => ev.type === 'closed').length;
            const nextClosedCount = nextProps.workspaceEvents.filter((ev) => ev.type === 'closed').length;
            if (currentClosedCount !== nextClosedCount) {
                return true;
            }
            // update if holidays change (store slice - stable reference until it actually changes)
            if (props.holidays !== nextProps.holidays) {
                return true;
            }
            // update if calendar search changes (store slice - stable reference until it changes)
            if (props.calendarSearch !== nextProps.calendarSearch) {
                const oldRes = currentRow &&
                    props.calendarSearch.results.find((r) => r.id === currentRow.employee);
                const newRes = nextRow &&
                    nextProps.calendarSearch.results.find((r) => r.id === nextRow.employee);
                if (oldRes !== newRes)
                    return true;
            }
            // update if calendar's sortedBy setting changed (primitive comparison)
            if (props.sortedBy !== nextProps.sortedBy) {
                return true;
            }
            // update if calendarFilters.hideWarnings changes
            const warningsFilterNow = props.calendarFilters
                ? props.calendarFilters.find((f) => f.hideWarnings)
                : null;
            const warningsFilterNext = nextProps.calendarFilters
                ? nextProps.calendarFilters.find((f) => f.hideWarnings)
                : null;
            if (warningsFilterNow !== warningsFilterNext) {
                return true;
            }
            if (nextProps.isCycleCalendar) {
                // cache cycle calendar references
                const currentCycleContext = props.cycleDetail.calendar?.contextMenuForColumn;
                const nextCycleContext = nextProps.cycleDetail.calendar?.contextMenuForColumn;
                if (util_1.miscUtil.safeStringify(currentCycleContext) !==
                    util_1.miscUtil.safeStringify(nextCycleContext)) {
                    return true;
                }
                if (util_1.miscUtil.safeStringify(props?.cycleGroups) !==
                    util_1.miscUtil.safeStringify(nextProps?.cycleGroups)) {
                    return true;
                }
                if (util_1.miscUtil.safeStringify(currentCycleContext?.expandedTemplateList) !==
                    util_1.miscUtil.safeStringify(nextCycleContext?.expandedTemplateList)) {
                    return true;
                }
            }
        }
        return false;
    }
    componentDidUpdate(prevProps) {
        const { setComputedRowHeight, computedRowHeight, idx, row } = this.props;
        if (!(0, util_1.isValue)(prevProps.calendar?.view) && (0, util_1.isValue)(this.props.calendar?.view)) {
            this.calendarView = this.props.calendar?.view ?? 'month';
        }
        if (setComputedRowHeight &&
            typeof idx !== typeof undefined &&
            typeof idx !== typeof null) {
            // update the computedRowHeight according to actual rendered height
            setTimeout(() => {
                const boundingBox = this.ref.current?.getBoundingClientRect();
                if (!computedRowHeight ||
                    (computedRowHeight &&
                        boundingBox?.height &&
                        computedRowHeight !== boundingBox?.height)) {
                    setComputedRowHeight(idx, boundingBox?.height ?? null);
                }
                // if computed height is over 200px, add the 'is-tall' class to the row
                if ((boundingBox?.height ?? 0) >= 200) {
                    this.ref.current?.classList.add('is-tall');
                }
            }, 200);
            // set computedRowHeight back to null when the max number of shifts in any one day is reduced. if we do that, the height will be recomputed again by the code above ^
            // this ensures that the row height is recomputed when we need to reduce it: for example when we remove some events from it, or when we switch calendar month to one with fewer shifts in that row
            if (Math.max(...row.events.map((col) => col.length)) <
                Math.max(...prevProps.row.events.map((col) => col.length))) {
                setTimeout(() => {
                    setComputedRowHeight(idx, null);
                }, 0);
            }
            // else if (currentColRowHeight > Math.max(...prevProps.row.events.map(col => col.length))) {
            //   console.log("updating")
            //   setTimeout(() => { setComputedRowHeight(idx, SINGLE_EVENT_HEIGHT * 16 * currentColRowHeight) }, 0)
            // }
        }
    }
    _getTooltipContent(data) {
        const { calendar, setCalendar, setCycleDetailCalendar, createShift, workspace, isCreatingShiftFromContextMenu, isCreatingEventsFromMultiSelect, isCycleCalendar, cycleDetail, calendarMultiSelect, } = this.props;
        const rows = [];
        const shiftTemplates = workspace?.shiftTemplates?.length
            ? workspace.shiftTemplates
            : [];
        /* employee */
        if (!calendarMultiSelect?.isSelectingTargets &&
            data.row.employee &&
            !['unassigned', 'offers'].includes(data.row.employee)) {
            rows.push(react_1.default.createElement("div", { className: 'evt-tt-r-employee', key: rows.length },
                react_1.default.createElement("span", { className: 'k' }, (0, util_1.t)('COL_TOOLTIP_EMPLOYEE')),
                react_1.default.createElement("span", { className: 'v' }, data.row.labelData.user ? data.row.labelData.user.name : '')));
        }
        /* position */
        if (!calendarMultiSelect?.isSelectingTargets &&
            data.row.sortData &&
            data.row.sortData.sortedBy === 'SORT_BY_POSITION' &&
            data.row.labelData.positions) {
            const pos = data.row.labelData.positions.find((p) => p.id === data.row.sortData.id);
            if (pos) {
                rows.push(react_1.default.createElement("div", { className: 'evt-tt-r-position', key: rows.length },
                    react_1.default.createElement("span", { className: 'k' }, (0, util_1.t)('POSITION')),
                    react_1.default.createElement("span", { className: 'v' },
                        react_1.default.createElement(_ui_1.Position, { pos: pos }))));
            }
        }
        /* locality */
        if (!calendarMultiSelect?.isSelectingTargets &&
            data.row.sortData &&
            data.row.sortData.sortedBy === 'SORT_BY_LOCALITY') {
            rows.push(react_1.default.createElement("div", { className: 'evt-tt-r-locality', key: rows.length },
                react_1.default.createElement("span", { className: 'k' }, (0, util_1.t)('LOCALITY')),
                react_1.default.createElement("span", { className: 'v' },
                    react_1.default.createElement(_ui_1.Locality, { id: data.row.sortData.id }))));
        }
        /* date */
        if (!calendarMultiSelect?.isSelectingTargets) {
            rows.push(react_1.default.createElement("div", { className: 'evt-tt-r-date', key: rows.length },
                react_1.default.createElement("span", { className: 'k' }, (0, util_1.t)('DATE')),
                react_1.default.createElement("span", { className: 'v' }, (0, util_1.cachedMoment)(calendar.date)
                    .startOf(calendar.view ?? this.calendarView)
                    .add(calendar.view === 'day' ? 0 : data.colIdx, 'days')
                    .format('D. M.'))));
        }
        /* insert events count */
        if (calendarMultiSelect?.isSelectingTargets) {
            rows.push(react_1.default.createElement("div", { className: 'evt-tt-r-insert', key: rows.length },
                react_1.default.createElement(_ui_1.Text, { weight: _ui_1.Text.WEIGHTS.BOLD, color: _ui_1.Text.COLORS.PRIMARY, type: _ui_1.Text.TYPES.BODY_MEDIUM }, calendarMultiSelect.action === 'copy'
                    ? (0, util_1.t)('MULTI_ACTION_COPY_CONFIRM', {
                        x: calendarMultiSelect.targets.length,
                    })
                    : calendarMultiSelect.action === 'applyShiftTemplate'
                        ? (0, util_1.t)('MULTI_ACTION_COPY_CONFIRM', {
                            x: calendarMultiSelect.targets.length,
                        })
                        : null)));
        }
        // =============================
        // CONTEXT MENU BUTTON HANDLERS:
        // =============================
        // add shift handler
        // // NOTE: IF you ever find yourself ever editing code here,
        // make sure to search `#ADD_SHIFT_PLUS_BUTTON` and edit it there as well.
        const handleAddShift = (e) => {
            const { isCycleCalendar, cycleDetail, cycleGroups } = this.props;
            e.preventDefault();
            e.stopPropagation();
            if (isCycleCalendar) {
                setCycleDetailCalendar({
                    ...cycleDetail,
                    calendar: {
                        contextMenuForColumn: undefined,
                    },
                });
            }
            else {
                if (calendar.contextMenuForColumn)
                    setCalendar({ contextMenuForColumn: undefined });
            }
            if (isCycleCalendar) {
                this.props.openModal(shift_1.ShiftModal, {
                    initialData: {
                        type: 'cycle',
                        shiftId: cycleDetail.lastSavedCycleShift?.data.id ?? undefined,
                        cycle: {
                            colId: data.colIdx,
                            groupId: cycleGroups[data.groupIdx].groupId,
                            eventId: data.row.events[data.colIdx].length,
                        },
                    },
                });
            }
            else {
                this.props.openModal(shift_1.ShiftModal, {
                    initialData: {
                        afterSubmit: data.row.employee === 'offers'
                            ? async (res) => {
                                if ((0, util_1.isDefined)(res)) {
                                    setTimeout(() => this.props.openModal(offers_1.Offers, {
                                        selectedShiftIds: Array.isArray(res)
                                            ? res.map((res) => res.id)
                                            : [res.id],
                                        newlyCreatedShifts: [res], // send newly created shift to this modal via prop, because it's probably not yet in store when the modal renders (websockets are not instant)
                                        action: 'create',
                                        createType: 'drop',
                                    }), 0);
                                }
                            }
                            : undefined,
                        type: 'live',
                        isOffersOrUnassigned: data.row.employee === 'offers'
                            ? 'offers'
                            : data.row.employee === 'unassigned'
                                ? 'unassigned'
                                : undefined,
                        data: {
                            userId: data.row.employee &&
                                data.row.employee !== 'unassigned' &&
                                data.row.employee !== 'offers'
                                ? data.row.employee
                                : undefined,
                            period: {
                                start: (0, util_1.cachedMoment)(calendar.date)
                                    .startOf(calendar.view ?? this.calendarView)
                                    .add(calendar.view === 'day' ? 0 : data.colIdx, 'days')
                                    .set({ hours: 8, minutes: 0, seconds: 0 }),
                                end: (0, util_1.cachedMoment)(calendar.date)
                                    .startOf(calendar.view ?? this.calendarView)
                                    .add(calendar.view === 'day' ? 0 : data.colIdx, 'days')
                                    .set({ hours: 16, minutes: 30, seconds: 0 }),
                            },
                            positionId: data.row.sortData &&
                                data.row.sortData.sortedBy === 'SORT_BY_POSITION'
                                ? data.row.sortData.id
                                : undefined,
                        },
                    },
                });
            }
        };
        // expands or collapses the list of shift templates in the context menu
        const handleExpandTemplateList = (e) => {
            const { isCycleCalendar } = this.props;
            e.preventDefault();
            e.stopPropagation();
            if (isCycleCalendar) {
                setCycleDetailCalendar({
                    contextMenuForColumn: {
                        ...cycleDetail.calendar.contextMenuForColumn,
                        expandedTemplateList: cycleDetail.calendar.contextMenuForColumn
                            .expandedTemplateList
                            ? undefined
                            : true,
                    },
                });
            }
            else {
                const newContextMenuVal = Object.assign({}, calendar.contextMenuForColumn, {
                    expandedTemplateList: calendar.contextMenuForColumn.expandedTemplateList
                        ? undefined
                        : true,
                });
                if (util_1.miscUtil.safeStringify(calendar.contextMenuForColumn) !==
                    util_1.miscUtil.safeStringify(newContextMenuVal))
                    setCalendar({ contextMenuForColumn: newContextMenuVal });
            }
        };
        // add shift from shift template handler
        const handleAddShiftFromTemplate = (e, tpl) => {
            const { idx, setCycleDetail } = this.props;
            e.preventDefault();
            e.stopPropagation();
            if (!isCreatingShiftFromContextMenu) {
                // don't do anything if we're already creating a shift. this function is messy if it's called twice for some reason.
                if (isCycleCalendar) {
                    const start = (0, util_1.cachedMoment)(tpl.shift.period.start).diff((0, util_1.cachedMoment)(tpl.shift.period.start).startOf('day'), 'minutes');
                    const end = (0, util_1.cachedMoment)(tpl.shift.period.end).diff((0, util_1.cachedMoment)(tpl.shift.period.end).startOf('day'), 'minutes');
                    const cycleData = { ...tpl.shift };
                    cycleData.start = start + data.colIdx * 1440;
                    cycleData.end = end + data.colIdx * 1440;
                    cycleData.duration = Math.abs(end - start);
                    cycleData.period = {
                        start: (0, util_1.cachedMoment)(calendar.date)
                            .add(data.colIdx, 'days')
                            .add(start, 'minutes'),
                        end: (0, util_1.cachedMoment)(calendar.date).add(data.colIdx, 'days').add(end, 'minutes'),
                    };
                    cycleData.id = idx + '_' + data.colIdx + '_' + '0';
                    cycleData.employees = 1;
                    if (cycleData.note)
                        delete cycleData.note;
                    setCycleDetail({
                        type: 'shift',
                        data: cycleData,
                    });
                    if (isCycleCalendar &&
                        cycleDetail?.calendar?.contextMenuForColumn?.colId === data.colIdx &&
                        cycleDetail?.calendar?.contextMenuForColumn?.groupId === idx) {
                        setCycleDetailCalendar({
                            contextMenuForColumn: undefined,
                        });
                    }
                }
                else {
                    const day = (0, util_1.formatYYYYMMDD)((0, util_1.cachedMoment)(calendar.date)
                        .startOf(calendar.view ?? this.calendarView)
                        .add(calendar.view === 'day' ? 0 : data.colIdx, 'days'));
                    util_1.calendarUtil.createShiftFromShiftTemplate(tpl, data.row.employee &&
                        data.row.employee !== 'unassigned' &&
                        data.row.employee !== 'offers'
                        ? data.row.employee
                        : null, day, createShift, () => {
                        const columnUniqueId = util_1.calendarUtil.getColIdentifier(day, data.row.employee);
                        if (calendar?.contextMenuForColumn &&
                            calendar.contextMenuForColumn.columnUniqueId === columnUniqueId &&
                            calendar.contextMenuForColumn.colIdx === data.colIdx) {
                            setCalendar({ contextMenuForColumn: undefined });
                        }
                    });
                }
            }
        };
        // opens a modal to create a new shift template
        const handleCreateShiftTemplate = (e) => {
            e.preventDefault();
            e.stopPropagation();
            this.props.openModal(shift_1.ShiftModal, {
                initialData: {
                    type: 'shiftTemplate',
                },
            });
            const newContextMenuVal = Object.assign({}, calendar.contextMenuForColumn, {
                expandedTemplateList: undefined,
            });
            if (util_1.miscUtil.safeStringify(calendar.contextMenuForColumn) !==
                util_1.miscUtil.safeStringify(newContextMenuVal))
                setCalendar({ contextMenuForColumn: newContextMenuVal });
        };
        // add absence handler
        const handleAddAbsence = (e) => {
            e.preventDefault();
            e.stopPropagation();
            if (calendar.contextMenuForColumn)
                setCalendar({ contextMenuForColumn: undefined });
            this.props.openModal(unavailability_modal_1.UnavailabilityModal, {
                initialData: {
                    period: {
                        start: (0, util_1.formatYYYYMMDD)((0, util_1.cachedMoment)(calendar.date)
                            .startOf(calendar.view ?? this.calendarView)
                            .add(calendar.view === 'day' ? 0 : data.colIdx, 'days')),
                    },
                    userId: data.row.employee &&
                        data.row.employee !== 'unassigned' &&
                        data.row.employee !== 'offers'
                        ? data.row.employee
                        : undefined,
                },
            });
        };
        // multiselect insert to targets handler
        const handleMultiSelectInsert = (e) => {
            e.preventDefault();
            e.stopPropagation();
            if (calendarMultiSelect?.action)
                util_1.multiSelectUtil.multiSelectExecuteAction(calendarMultiSelect.action);
        };
        // multiselect cancel selection handler
        const handleMultiSelectCancel = (e) => {
            e.preventDefault();
            e.stopPropagation();
            util_1.multiSelectUtil.multiSelectClear();
        };
        return (react_1.default.createElement(react_1.default.Fragment, null,
            rows,
            react_1.default.createElement("div", { className: 'evt-tt-cm' },
                !calendarMultiSelect?.isSelectingTargets && (react_1.default.createElement("div", { key: 'context_add_shift', onMouseDown: handleAddShift, onTouchStart: handleAddShift },
                    react_1.default.createElement(_ui_1.Icon, { ico: 'plus' }),
                    (0, util_1.t)('COL_TOOLTIP_CM_ADD_SHIFT'))),
                !calendarMultiSelect?.isSelectingTargets && (react_1.default.createElement("div", { key: 'context_add_shift_from_tmp', onMouseDown: (e) => {
                        e.preventDefault();
                        e.stopPropagation();
                        handleExpandTemplateList(e);
                    }, onTouchStart: (e) => {
                        e.preventDefault();
                        e.stopPropagation();
                        handleExpandTemplateList(e);
                    } },
                    react_1.default.createElement(_ui_1.Icon, { ico: 'plus' }),
                    (0, util_1.t)('COL_TOOLTIP_CM_ADD_SHIFT_FROM_TPL'),
                    (isCycleCalendar &&
                        cycleDetail.calendar?.contextMenuForColumn?.expandedTemplateList) ||
                        calendar?.contextMenuForColumn?.expandedTemplateList ? (react_1.default.createElement("div", { className: 'ds-c-evt-tt-shift-template-list' }, isCreatingShiftFromContextMenu ? (react_1.default.createElement(_ui_1.Icon, { ico: _ui_1.Icon.ICONS.loader })) : shiftTemplates.length ? (shiftTemplates.map((tpl) => {
                        return (react_1.default.createElement("div", { key: tpl.id, onMouseDown: (e) => {
                                handleAddShiftFromTemplate(e, tpl);
                            }, onTouchStart: (e) => {
                                handleAddShiftFromTemplate(e, tpl);
                            } }, tpl.name));
                    })) : (react_1.default.createElement("div", { onMouseDown: (e) => {
                            handleCreateShiftTemplate(e);
                        }, onTouchStart: (e) => {
                            handleCreateShiftTemplate(e);
                        } }, (0, util_1.t)('COL_TOOLTIP_CM_CREATE_TPL'))))) : null)),
                !['unassigned', 'offers'].includes(data.row.employee) &&
                    !isCycleCalendar &&
                    !calendarMultiSelect?.isSelectingTargets && (react_1.default.createElement("div", { key: 'context_add_absence', onMouseDown: handleAddAbsence, onTouchStart: handleAddAbsence },
                    react_1.default.createElement(_ui_1.Icon, { ico: 'plus' }),
                    (0, util_1.t)('COL_TOOLTIP_CM_ADD_ABSENCE'))),
                calendarMultiSelect?.isSelectingTargets &&
                    (isCreatingEventsFromMultiSelect ? (react_1.default.createElement(_ui_1.Flex, null,
                        react_1.default.createElement(_ui_1.Icon, { ico: _ui_1.Icon.ICONS.loader }))) : (react_1.default.createElement("div", { key: 'context_ms_insert_to_targets', onMouseDown: handleMultiSelectInsert, onTouchStart: handleMultiSelectInsert },
                        react_1.default.createElement(_ui_1.Icon, { ico: _ui_1.Icon.ICONS.check }),
                        (0, util_1.t)('APPLY_TEMPLATE_APPLY')))),
                calendarMultiSelect?.isSelectingTargets &&
                    !isCreatingEventsFromMultiSelect && (react_1.default.createElement("div", { key: 'context_ms_cancel', onMouseDown: handleMultiSelectCancel, onTouchStart: handleMultiSelectCancel },
                    react_1.default.createElement(_ui_1.Icon, { ico: _ui_1.Icon.ICONS.close1 }),
                    (0, util_1.t)('CANCEL'))))));
    }
    _getRowHTML(row, idx, isHighlighted) {
        const { calendar, calendarSearch, setCalendarMultiSelect, setCalendar, workspaceEvents, holidays, whichSection, labelWidthRem, workspace, isCycleCalendar, showRepeat, period, isSettingCalendarMultiselect, setCycleDetailCalendar, cycleDetail, evtIdx, cycleGroupsCallback, sortedBy, calendarMultiSelect, cycleGroups, } = this.props;
        const contractTypes = [
            ...(workspace?.contractTypes ?? []),
            {
                id: 'external',
                name: (0, util_1.t)('ORG_SP_SETTINGS_MODULES_EXTERNAL'),
                rules: {
                    vacationFund: true,
                    fixedWorkHours: false,
                },
            },
        ];
        // const { sortData } = row
        // const positions = this.props.positions || []
        if (!calendar || !calendarSearch)
            return null;
        const isTopSection = row.employee === 'unassigned' || row.employee === 'offers';
        let onClickHandler = () => {
            ;
            (() => { })();
        };
        if (row.labelData.title &&
            [(0, util_1.t)('OPEN_SHIFTS'), (0, util_1.t)('CONTESTS')].includes(row.labelData.title) &&
            row.events) {
            // flatten the events lazily, only when the label is actually clicked - doing this on every
            // render (flatten + a moment().format() per event) was measured at up to 8ms per call
            onClickHandler = () => {
                const evts = row.events
                    .reduce((a, s) => {
                    return a.concat(s);
                }, [])
                    .map((s) => Object.assign({}, s.data, {
                    day: (0, util_1.formatYYYYMMDD)((0, util_1.cachedMoment)(s.data.period.start)),
                }));
                if (evts?.length) {
                    setCalendarMultiSelect({
                        sourceEvents: evts,
                    });
                }
            };
        }
        // prepare the starts and ends of contracts that this row's user has in displayed calendar period
        const contractStarts = {};
        const contractEnds = {};
        if (row.labelData.userHasContractsInCalendarPeriod &&
            row.labelData.user.contracts &&
            calendar.view !== 'day') {
            row.labelData.user.contracts.forEach((con) => {
                if (!con.period)
                    return false;
                if ((0, util_1.cachedMoment)(con.period.start).isSameOrAfter((0, util_1.cachedMoment)(calendar.date).startOf(calendar.view ?? this.calendarView), 'day') &&
                    (0, util_1.cachedMoment)(con.period.start).isSameOrBefore((0, util_1.cachedMoment)(calendar.date).endOf(calendar.view ?? this.calendarView), 'day')) {
                    contractStarts[(0, util_1.formatYYYYMMDD)((0, util_1.cachedMoment)(con.period.start))] = {
                        type: con.type,
                        minutes: con.options?.minutesOfWorkPerMonth,
                    };
                }
                if ((0, util_1.cachedMoment)(con.period.end).isSameOrAfter((0, util_1.cachedMoment)(calendar.date).startOf(calendar.view ?? this.calendarView), 'day') &&
                    (0, util_1.cachedMoment)(con.period.end).isSameOrBefore((0, util_1.cachedMoment)(calendar.date).endOf(calendar.view ?? this.calendarView), 'day')) {
                    contractEnds[(0, util_1.formatYYYYMMDD)((0, util_1.cachedMoment)(con.period.end))] = {
                        type: con.type,
                        minutes: con.options?.minutesOfWorkPerMonth,
                    };
                }
            });
        }
        const desiredEmployee = this.props.employees[row.employee];
        const contractInSelectedMonth = desiredEmployee?.contracts
            ? desiredEmployee?.contracts.filter((contract) => util_1.calendarUtil.isPeriodsOverlap(contract?.period, {
                start: (0, util_1.cachedMoment)(calendar.date).startOf(calendar.view ?? this.calendarView),
                end: (0, util_1.cachedMoment)(calendar.date).endOf(calendar.view ?? this.calendarView),
            }))
            : [];
        const hasFixedHoursContract = contractTypes
            ?.filter((ctp) => ctp.id === row.labelData?.user?.contractType ||
            contractInSelectedMonth.some((item) => ctp.id === item.type))
            .some((item) => item?.rules?.fixedWorkHours);
        const hasContractWithVacationFund = contractTypes
            ?.filter((ctp) => ctp.id === row.labelData?.user?.contractType ||
            contractInSelectedMonth.some((item) => ctp.id === item.type))
            .some((item) => item?.rules?.vacationFund);
        const empStats = !isTopSection && calendar && calendar.roleStats
            ? calendar.roleStats[row.employee]
            : null;
        const { monthPlannedMinutesByContract, monthPlannedMinutesByPosition, monthContractMinutesByContract, monthOverTimeMinutesByContract, monthOverTimeMinutesByPosition, balancingPeriodContractMinutesByContract, balancingPeriodPlannedMinutesByContract, balancingPeriodPlannedMinutesByPosition, } = empStats || {};
        const wsBalancingPeriod = workspace?.settings?.balancingPeriod;
        const wsBalancingPeriodRelevant = !!wsBalancingPeriod &&
            (wsBalancingPeriod.unit !== 'month' || wsBalancingPeriod.amount !== 1);
        // let vacationTaken = (workspace?.displayVacationsAsDays)
        //   ? empStats?.yearVacationDays
        //   : empStats?.yearVacationMinutes
        // let vacationFund = (workspace?.displayVacationsAsDays)
        //   ? empStats?.yearVacationDays + empStats?.yearVacationRemainingDays
        //   : empStats?.yearVacationMinutes + empStats?.yearVacationRemainingMinutes
        const vacationStats = !isTopSection && calendar && calendar.vacations
            ? calendar.vacations[row.employee]
            : null;
        // const userContractVacation =
        //  row.sortData?.sortedBy === SORT_BY.CONTRACT
        //    ? (vacationStats?.find(
        //        (stats) => stats.contractType === row.sortData.id
        //      ) ?? {
        //        amount: 0,
        //        unit: workspace?.displayVacationsAsDays ? 'day' : 'hour',
        //      })
        //    : undefined
        const userVacationAmount = vacationStats?.reduce((acc, curr) => acc + (curr.amount ?? 0), 0);
        let vacationFund = hasContractWithVacationFund
            ? workspace?.displayVacationsAsDays
                ? userVacationAmount
                : (userVacationAmount ?? 0) * 60
            : 0; // if user's contracts don't have vacation fund, just 0
        let vacationTaken = new maybe_1.Maybe(workspace?.displayVacationsAsDays
            ? empStats?.yearVacationDays
            : empStats?.yearVacationMinutes).get(() => 0);
        if (workspace?.displayVacationsAsDays) {
            vacationFund = util_1.numberUtil.round2decimals(vacationFund);
            vacationTaken = util_1.numberUtil.round2decimals(vacationTaken);
        }
        else {
            vacationTaken = util_1.timeUtil.asHour(vacationTaken);
            vacationFund = util_1.timeUtil.asHour(vacationFund);
        }
        const isExternalEmployeeRow = Boolean(row?.labelData?.user?.external);
        const hasEmployeesAccess = util_1.permissionsUtil.canWrite(const_1.PERMISSIONS.WORKSPACE.EMPLOYEES) ||
            util_1.permissionsUtil.canRead(const_1.PERMISSIONS.WORKSPACE.EMPLOYEES);
        const rowLabelTitle = row?.labelData?.title;
        const rowPositions = row.labelData.user?.positions;
        const rowLocalities = row.labelData.user?.localities;
        const rowContracts = row.labelData.user?.contracts;
        const multiplePositions = rowPositions?.length > 1;
        const multipleLocalities = rowLocalities?.length > 1;
        const multipleContracts = rowContracts?.filter((c) => !isDateInThePast(c?.period?.end)).length > 1;
        const isPreviousYear = (0, util_1.cachedMoment)(calendar.date, 'YYYY-MM-DD').isBefore((0, moment_1.default)().startOf('year'));
        const rowLabel = (react_1.default.createElement("div", { className: 'ds-c-row-label row_' +
                row.employee +
                (isTopSection ? ' is-top-section' : ''), style: {
                width: labelWidthRem.toString() + 'rem',
                minWidth: labelWidthRem.toString() + 'rem',
                maxWidth: labelWidthRem.toString() + 'rem',
                borderLeft: row?.labelData?.user?.employeeWarnings &&
                    row.labelData.user.employeeWarnings.filter((w) => w.type !== 'dummy')
                        .length
                    ? '0.43ex solid #ce0b24'
                    : '0.43ex solid transparent',
            }, onMouseDown: onClickHandler, "data-testid": `calendar-row-header-${row.employee}` },
            react_1.default.createElement("div", { className: 'ds-c-row-label-left' }),
            react_1.default.createElement("div", { className: 'ds-c-row-label-right' },
                react_1.default.createElement("div", { className: 'ds-c-row-title' }, isCycleCalendar && cycleGroupsCallback ? (react_1.default.createElement(_ui_1.Input, { style: _ui_1.Input.STYLES.UNDERLINE, size: _ui_1.Input.SIZES.SMALL, type: _ui_1.Input.TYPES.TEXT, value: rowLabelTitle, onChange: (val) => {
                        const data = { id: idx, name: val };
                        cycleGroupsCallback(data);
                    } })) : (rowLabelTitle)),
                react_1.default.createElement("div", { className: 'ds-c-row-text' },
                    isTopSection || isCycleCalendar ? row.labelData.text : null,
                    !isTopSection && calendar && calendar.roleStats && empStats ? ( // eslint-disable-next-line
                    react_1.default.createElement("table", { className: 'ds-c-row-label-hrs-table' },
                        react_1.default.createElement("tbody", null,
                            react_1.default.createElement("tr", null,
                                react_1.default.createElement(month_planned_minutes_cell_1.MonthPlannedMinutesCell, { sortData: row.sortData, 
                                    // ot
                                    monthOverTimeMinutes: empStats.monthOverTimeMinutes, monthOverTimeMinutesByPosition: monthOverTimeMinutesByPosition, monthOverTimeMinutesByContract: monthOverTimeMinutesByContract, 
                                    // contract
                                    monthContractMinutes: empStats.monthContractMinutes, monthContractMinutesByContract: monthContractMinutesByContract
                                        ?.filter(util_1.isValue)
                                        .filter((t) => (0, util_1.isValue)(t.contractType) && (0, util_1.isValue)(t.minutes)) ?? [], 
                                    // planned
                                    monthPlannedMinutes: empStats.monthPlannedMinutes, monthPlannedMinutesByContract: monthPlannedMinutesByContract
                                        ?.filter(util_1.isValue)
                                        .filter((t) => (0, util_1.isValue)(t.contractType) && (0, util_1.isValue)(t.minutes)) ?? [], monthPlannedMinutesByPosition: monthPlannedMinutesByPosition
                                        ?.filter(util_1.isValue)
                                        .filter((t) => (0, util_1.isValue)(t.positionId) && (0, util_1.isValue)(t.minutes)) ?? [] }),
                                wsBalancingPeriodRelevant && hasFixedHoursContract ? (react_1.default.createElement(balancing_period_planned_minutes_cell_1.BalancingPeriodPlannedMinutesCell, { sortData: row.sortData, balancingPeriodContractMinutes: empStats.balancingPeriodContractMinutes, balancingPeriodPlannedMinutes: empStats.balancingPeriodPlannedMinutes, balancingPeriodContractMinutesByContract: balancingPeriodContractMinutesByContract
                                        ?.filter(util_1.isValue)
                                        .filter((t) => (0, util_1.isValue)(t.contractType) && (0, util_1.isValue)(t.minutes)) ?? [], balancingPeriodPlannedMinutesByContract: balancingPeriodPlannedMinutesByContract
                                        ?.filter(util_1.isValue)
                                        .filter((t) => (0, util_1.isValue)(t.contractType) && (0, util_1.isValue)(t.minutes)) ?? [], balancingPeriodPlannedMinutesByPosition: balancingPeriodPlannedMinutesByPosition
                                        ?.filter(util_1.isValue)
                                        .filter((t) => (0, util_1.isValue)(t.positionId) && (0, util_1.isValue)(t.minutes)) ?? [] })) : (react_1.default.createElement("td", null,
                                    react_1.default.createElement(_ui_1.Flex, { justify: 'center' }, "\u2014"))),
                                hasContractWithVacationFund && isPreviousYear ? (react_1.default.createElement(no_known_value_1.NoKnownValue, null)) : (react_1.default.createElement("td", null,
                                    react_1.default.createElement("span", { className: 'no-arrow small' }),
                                    workspace?.displayVacationsAsDays
                                        ? vacationTaken
                                            ? `${vacationTaken} ${(0, util_1.t)('DAY_SHORTEST')}`
                                            : ''
                                        : (0, format_hours_1.formatHours)(Number(vacationTaken))))),
                            react_1.default.createElement("tr", null,
                                react_1.default.createElement(month_contract_minutes_cell_1.MonthContractMinutesCell, { sortData: row.sortData, monthContractMinutes: empStats.monthContractMinutes, multipleContracts: multipleContracts, multiplePositions: multiplePositions, multipleLocalities: multipleLocalities }),
                                wsBalancingPeriodRelevant && hasFixedHoursContract ? (react_1.default.createElement(balancing_period_contract_minutes_cell_1.BalancingPeriodContractMinutesCell, { sortData: row.sortData, balancingPeriodContractMinutes: empStats.balancingPeriodContractMinutes, multipleContracts: multipleContracts, multiplePositions: multiplePositions, multipleLocalities: multipleLocalities })) : (react_1.default.createElement("td", null,
                                    react_1.default.createElement(_ui_1.Flex, { justify: 'center' }, "\u2014"))),
                                hasContractWithVacationFund && isPreviousYear ? (react_1.default.createElement(no_known_value_1.NoKnownValue, null)) : (
                                // im sorry
                                // Prepared for - https://app.clickup.com/t/86c2e0g1q
                                // <td>
                                //   {row.sortData?.sortedBy === SORT_BY.CONTRACT ? (
                                //     userContractVacation?.unit === 'hour' ? (
                                //       <>
                                //         <span className='no-arrow small' />
                                //         {isValue(userContractVacation?.amount)
                                //           ? formatHours(userContractVacation?.amount)
                                //           : `${userContractVacation?.amount} ${t('DAY_SHORTEST')}`}
                                //       </>
                                //     ) : (
                                //       <Flex justify='center'>&mdash;</Flex>
                                //     )
                                //   ) : (
                                //     <>
                                //       <span className='no-arrow small' />
                                //       {workspace?.displayVacationsAsDays
                                //         ? `${vacationFund} ${t('DAY_SHORTEST')}`
                                //         : formatHours(vacationFund)}
                                //     </>
                                //   )}
                                // </td>
                                react_1.default.createElement("td", null,
                                    react_1.default.createElement("span", { className: 'no-arrow small' }),
                                    workspace?.displayVacationsAsDays
                                        ? `${vacationFund} ${(0, util_1.t)('DAY_SHORTEST')}`
                                        : (0, format_hours_1.formatHours)(vacationFund))))))) : null))));
        const maxVerticalShift = row.events.reduce((acc, eventColumn) => {
            const columnMax = eventColumn.reduce((evAcc, event) => Math.max(evAcc, event.data.verticalShift ?? 0), 0);
            return Math.max(acc, columnMax);
        }, 0);
        // precompute day-keyed lookups once for the whole row, instead of re-scanning holidays and
        // workspaceEvents (with a moment().format() per item) inside every column below
        const todayStr = (0, util_1.formatYYYYMMDD)((0, moment_1.default)());
        const holidayByDay = new Map();
        holidays.forEach((hol) => {
            if (hol.type === 'public') {
                const key = (0, util_1.formatYYYYMMDD)((0, util_1.cachedMoment)(hol.date));
                if (!holidayByDay.has(key))
                    holidayByDay.set(key, hol);
            }
        });
        const closedByDay = new Map();
        workspaceEvents.forEach((evt) => {
            if (evt.type === 'closed') {
                const key = (0, util_1.formatYYYYMMDD)((0, util_1.cachedMoment)(evt.period.start));
                if (!closedByDay.has(key))
                    closedByDay.set(key, evt);
            }
        });
        // HERE
        return (react_1.default.createElement("div", { ref: this.ref, style: {
                // minHeight: this.props.computedRowHeight ? (this.props.computedRowHeight + 'px') : undefined,
                height: calendar.view === 'day'
                    ? `${(maxVerticalShift + 1) * 3.1875}rem`
                    : undefined,
            }, className: `ds-c-row ${row.className || ''} ${row.isDayToday ? 'is-day-today' : ''} ${isHighlighted ? 'is-highlighted' : ''}` },
            whichSection === 'bottom' &&
                !isExternalEmployeeRow &&
                hasEmployeesAccess ? (react_1.default.createElement("div", { className: 'ds-c-row-label-modal-wrapper', onClick: () => 
                // setModal('employee-profile', { userId: row?.labelData?.user?.id })
                this.props.openModal(employee_card_v2_1.EmployeeCardV2, {
                    userId: row?.labelData?.user?.id,
                }) }, rowLabel)) : (rowLabel),
            row.events.map((col, colIdx) => {
                const day = isCycleCalendar
                    ? (0, util_1.formatYYYYMMDD)((0, util_1.cachedMoment)(calendar.date).add(calendar.view !== 'day' ? colIdx : 0, 'days'))
                    : (0, util_1.formatYYYYMMDD)((0, util_1.cachedMoment)(calendar.date)
                        .startOf(calendar.view ?? this.calendarView)
                        .add(calendar.view !== 'day' ? colIdx : 0, 'days'));
                // one moment per column, reused for all the checks below (clone before any mutating op)
                const mDay = (0, util_1.cachedMoment)(day);
                const isLockedDay = util_1.miscUtil.isMyCalendarLocked(mDay.clone().endOf('day'), workspace);
                const isWeekend = [6, 7].includes(mDay.isoWeekday());
                const isHoliday = holidayByDay.get(day);
                const isPast = day < todayStr;
                const isToday = day === todayStr;
                const dayIsClosed = closedByDay.get(day);
                const columnUniqueId = util_1.calendarUtil.getColIdentifier(day, row.employee);
                let firstShiftInColAlreadyRendered = false;
                const isCyclePreview = showRepeat && colIdx >= (period ?? -1);
                const isSelectedAsTarget = calendarMultiSelect?.isSelectingTargets &&
                    calendarMultiSelect?.targets?.some((t) => t.date === day && t.userId === row?.employee);
                // prepare the column tooltip, if needed according to calendar.contextMenuForColumn
                let tooltipHTML = null;
                if (
                // display column tooltip in Cycle Calendar
                (isCycleCalendar &&
                    cycleDetail.calendar?.contextMenuForColumn?.groupId === idx &&
                    cycleDetail.calendar?.contextMenuForColumn?.colId === colIdx) ||
                    // display column tooltip in Manager Calendar
                    (calendar?.contextMenuForColumn &&
                        calendar.contextMenuForColumn.columnUniqueId === columnUniqueId &&
                        calendar.contextMenuForColumn.colIdx === colIdx)) {
                    tooltipHTML = (react_1.default.createElement("div", { className: 'evt-tt' }, this.getTooltipContent({
                        row,
                        colIdx,
                        groupIdx: idx,
                    })));
                }
                // compute the current balancing period start & end, with respect to this row's date, so it can be displayed in calendar
                const cbp = util_1.timeUtil.getCurrentBalancingPeriod(wsBalancingPeriod, mDay.clone());
                const isStartOfBalancingPeriod = cbp?.end && mDay.isSame((0, moment_1.default)(cbp.end), 'day');
                // prepare the hover buttons
                const hoverBtns = (react_1.default.createElement("div", { className: 'ds-c-col-hover-btns' },
                    !calendarMultiSelect?.isSelectingTargets &&
                        !isExternalEmployeeRow &&
                        !isCyclePreview &&
                        (!isLockedDay || isCycleCalendar) && (react_1.default.createElement(_ui_1.Button, { onClick: (e) => {
                            // don't open anything if an Event's context menu tooltip was recently closed (within a few milliseconds)
                            if (window.dsMsTooltipWasRecentlyClosed &&
                                Date.now() -
                                    parseInt(window.dsMsTooltipWasRecentlyClosed.toString()) <=
                                    500) {
                                e.stopPropagation();
                                e.preventDefault();
                                return false;
                            }
                            // NOTE: IF you ever find yourself ever editing code here,
                            // make sure to edit it in `handleAddShift` as well.
                            // #ADD_SHIFT_PLUS_BUTTON
                            // Do not delete this ^; this tag is mentioned somewhere else in the code
                            // for developer experience.
                            if (isCycleCalendar) {
                                this.props.openModal(shift_1.ShiftModal, {
                                    initialData: {
                                        type: 'cycle',
                                        shiftId: this.props.cycleDetail.lastSavedCycleShift?.data.id ??
                                            undefined,
                                        cycle: {
                                            colId: colIdx,
                                            groupId: cycleGroups[idx].groupId,
                                            eventId: 0,
                                        },
                                    },
                                });
                                return;
                            }
                            if (!isCycleCalendar) {
                                const period = {
                                    start: (0, util_1.cachedMoment)(calendar.date)
                                        .startOf(calendar.view ?? this.calendarView)
                                        .add(calendar.view === 'day' ? 0 : colIdx, 'days'),
                                    end: (0, util_1.cachedMoment)(calendar.date)
                                        .startOf(calendar.view ?? this.calendarView)
                                        .add(calendar.view === 'day' ? 0 : colIdx, 'days'),
                                };
                                if (calendar.view !== 'day') {
                                    period.start.set({ hours: 8, minutes: 0, seconds: 0 });
                                    period.end.set({ hours: 16, minutes: 30, seconds: 0 });
                                }
                                else {
                                    period.start.set({
                                        hours: colIdx,
                                        minutes: 0,
                                        seconds: 0,
                                    });
                                    period.end.set({
                                        hours: colIdx + 8,
                                        minutes: 30,
                                        seconds: 0,
                                    });
                                }
                                this.props.openModal(shift_1.ShiftModal, {
                                    initialData: {
                                        type: 'live',
                                        isOffersOrUnassigned: row.employee === 'offers'
                                            ? 'offers'
                                            : row.employee === 'unassigned'
                                                ? 'unassigned'
                                                : undefined,
                                        data: {
                                            userId: row.employee &&
                                                row.employee !== 'unassigned' &&
                                                row.employee !== 'offers'
                                                ? row.employee
                                                : undefined,
                                            period,
                                            positionId: row.sortData?.sortedBy === sort_by_1.SORT_BY.POSITION &&
                                                (0, util_1.isDefined)(row.sortData?.id)
                                                ? row.sortData.id
                                                : undefined,
                                        },
                                        afterSubmit: row.employee === 'offers'
                                            ? async (res) => {
                                                if ((0, util_1.isDefined)(res)) {
                                                    setTimeout(() => this.props.openModal(offers_1.Offers, {
                                                        selectedShiftIds: Array.isArray(res)
                                                            ? res.map((res) => res.id)
                                                            : [res.id],
                                                        newlyCreatedShifts: [res], // send newly created shift to this modal via prop, because it's probably not yet in store when the modal renders (websockets are not instant)
                                                        action: 'create',
                                                        createType: 'drop',
                                                    }), 0);
                                                }
                                            }
                                            : undefined,
                                    },
                                });
                            }
                            else {
                                this.props.openModal(unavailability_modal_1.UnavailabilityModal, {
                                    initialData: {
                                        userId: row.employee,
                                        period: {
                                            start: (0, util_1.formatYYYYMMDD)((0, util_1.cachedMoment)(row.day)),
                                        },
                                        periodType: calendar.view === 'day'
                                            ? graphql_1.PeriodType.PartDay
                                            : undefined,
                                        categoryId: use_workspace_unavailability_categories_1.UNAVAILABILITY_VALUE,
                                    },
                                });
                            }
                        }, onContextMenu: (e) => {
                            e.stopPropagation();
                            e.preventDefault();
                            if (isCycleCalendar) {
                                setCycleDetailCalendar({
                                    contextMenuForColumn: {
                                        groupId: cycleGroups[idx].groupId,
                                        colId: colIdx,
                                        eventId: evtIdx,
                                    },
                                });
                            }
                            else {
                                if (!calendar.contextMenuForColumn ||
                                    calendar.contextMenuForColumn.columnUniqueId !==
                                        columnUniqueId) {
                                    setCalendar(Object.assign({}, calendar, {
                                        contextMenuForColumn: {
                                            columnUniqueId,
                                            rowEmployee: row.employee,
                                            colIdx,
                                        },
                                    }));
                                }
                            }
                        }, ico: _ui_1.Icon.ICONS.plus })),
                    !calendarMultiSelect?.isSelectingTargets &&
                        row.employee === 'unassigned' &&
                        !isLockedDay && (react_1.default.createElement(_ui_1.Button, { onClick: (e) => {
                            // don't open anything if an Event's context menu tooltip was recently closed (within a few milliseconds)
                            if (window.dsMsTooltipWasRecentlyClosed &&
                                Date.now() -
                                    parseInt(window.dsMsTooltipWasRecentlyClosed.toString()) <=
                                    500) {
                                e.stopPropagation();
                                e.preventDefault();
                                return false;
                            }
                            this.props.setModal('template-apply', {
                                date: (0, util_1.formatYYYYMMDD)((0, util_1.cachedMoment)(calendar.date)
                                    .startOf(calendar.view ?? this.calendarView)
                                    .add(calendar.view === 'day' ? 0 : colIdx, 'days')),
                            });
                            if (calendar.contextMenuForColumn)
                                setCalendar({ contextMenuForColumn: undefined });
                            e.stopPropagation();
                        }, onContextMenu: (e) => {
                            e.stopPropagation();
                            e.preventDefault();
                            setCalendar({
                                contextMenuForColumn: {
                                    columnUniqueId,
                                    rowEmployee: row.employee,
                                    colIdx,
                                },
                            });
                        }, ico: _ui_1.Icon.ICONS.open })),
                    calendarMultiSelect?.isSelectingTargets &&
                        row.employee !== 'offers' && (react_1.default.createElement(_ui_1.Button, { disabled: isSettingCalendarMultiselect, onClick: (e) => {
                            e.stopPropagation();
                            e.preventDefault();
                            const isAlreadySelected = calendarMultiSelect?.targets?.some((t) => t.userId === row.employee && t.date === day);
                            if (isAlreadySelected) {
                                // remove from selection
                                setCalendarMultiSelect(undefined, undefined, {
                                    userId: row.employee,
                                    date: day,
                                });
                            }
                            else {
                                // add to selection
                                setCalendarMultiSelect(undefined, {
                                    userId: row.employee,
                                    date: day,
                                });
                            }
                        }, onContextMenu: calendarMultiSelect?.targets?.some((t) => t.userId === row.employee && t.date === day) /* only allow opening context menu here when user right-clicks on *selected* target */
                            ? (e) => {
                                e.stopPropagation();
                                e.preventDefault();
                                if (!calendar.contextMenuForColumn ||
                                    calendar.contextMenuForColumn.columnUniqueId !==
                                        columnUniqueId) {
                                    setCalendar({
                                        contextMenuForColumn: {
                                            columnUniqueId,
                                            rowEmployee: row.employee,
                                            colIdx,
                                        },
                                    });
                                }
                            }
                            : (e) => {
                                e.stopPropagation();
                                e.preventDefault(); /* otherwise just block browser's default right-click functionality here */
                            }, ico: calendarMultiSelect?.targets?.some((t) => t.userId === row.employee && t.date === day)
                            ? _ui_1.Icon.ICONS.check
                            : _ui_1.Icon.ICONS.duplicate, label: calendarMultiSelect?.targets?.some((t) => t.userId === row.employee && t.date === day)
                            ? (0, util_1.t)('MULTI_SELECTED')
                            : (0, util_1.t)('CHOOSE') }))));
                return (react_1.default.createElement("div", { className: 'ds-c-col' +
                        ' is-view-' +
                        calendar.view +
                        (isWeekend ? ' is-weekend' : '') +
                        (isHoliday ? ' is-holiday' : '') +
                        (isPast && !isCycleCalendar ? ' is-past' : '') +
                        (isToday ? ' is-today' : '') +
                        (isStartOfBalancingPeriod ? ' is-start-of-balancing-period' : '') +
                        (dayIsClosed && !isCycleCalendar ? ' is-closed' : '') +
                        ' ds-droppable' +
                        (' ' + util_1.calendarUtil.getColIdentifier(day)) +
                        (' ' + columnUniqueId) +
                        (isCyclePreview ? ' is-preview' : '') +
                        (isSelectedAsTarget ? ' is-ms-selected' : ''), key: 'row_col_' +
                        idx.toString() +
                        '_' +
                        colIdx.toString(), "data-droppable": util_1.miscUtil.safeStringify({
                        employee: row.employee,
                        colIdx,
                    }), onContextMenu: (e) => {
                        // prevent default browser's right-click handler on the column itself
                        e.preventDefault();
                        // if we have context menu for whatever event/column open, close it when we click directly on the empty column space
                        if (calendar.contextMenuForColumn)
                            setCalendar({ contextMenuForColumn: undefined });
                    }, "data-testid": `dayIndex-${colIdx}-rowId-${row.employee}` },
                    react_1.default.createElement(contract_start_end_1.ContractStartEnd, { contractStarts: contractStarts, contractEnds: contractEnds, day: day }),
                    col.map((evt, evtIdx) => {
                        let isTransparent = false;
                        if (row.sortData) {
                            if (!isTransparent &&
                                evt.type === 'shift' &&
                                row?.sortData?.sortedBy === 'SORT_BY_POSITION' &&
                                evt.data.positionId !== row.sortData.id)
                                isTransparent = true;
                            if (!isTransparent &&
                                evt.type === 'shift' &&
                                row?.sortData?.sortedBy === 'SORT_BY_LOCALITY' &&
                                evt.data.localityId !== row.sortData.id)
                                isTransparent = true;
                            if (!isTransparent &&
                                evt.type === 'shift' &&
                                row?.sortData?.sortedBy === 'SORT_BY_CONTRACT' &&
                                evt.data.contractType !== row.sortData.id)
                                isTransparent = true;
                        }
                        let isFirstShiftInDay = false;
                        if (!firstShiftInColAlreadyRendered && evt.type === 'shift') {
                            isFirstShiftInDay = true;
                            firstShiftInColAlreadyRendered = true;
                        }
                        return (react_1.default.createElement(event_1.default, { type: evt.type, data: evt.data, verticalShift: evt.data.verticalShift, key: 'evt_' +
                                idx.toString() +
                                '_' +
                                colIdx.toString() +
                                '_' +
                                evtIdx.toString(), day: day, isLockedDay: isLockedDay, rowEmployee: row.employee, isCycleCalendar: isCycleCalendar ?? false, cycleCalendar: calendar, isTransparent: isTransparent, isCyclePreview: isCyclePreview, idx: idx, cycleGroups: cycleGroups, evtIdx: evtIdx, isExternalEmployeeRow: isExternalEmployeeRow, isFirstShiftInDay: isFirstShiftInDay, whichSection: whichSection, sortedBy: sortedBy, sortData: row.sortData }));
                    }),
                    tooltipHTML ? (react_1.default.createElement(_ui_1.Tooltip, { clickable: true, openOnMount: true, anchor: hoverBtns, width: '11.875rem', closeCallback: () => {
                            // when the tooltip is closed, set the window.dsMsTooltipWasRecentlyClosed flag to current timestamp.
                            // it's used to prevent opening the editation modals when clicked on hoverbtns immediatelly after the event tooltip is closed.
                            window.dsMsTooltipWasRecentlyClosed = Date.now();
                        } }, tooltipHTML)) : (hoverBtns)));
            })));
    }
    // adds 'verticalShift' property to mutually overlapping events
    // in the row, which is then used to prevent shift overlapping in 'day' view
    _getDayRowWithoutOverlapping(rowParam) {
        const row = Object.assign({}, rowParam);
        if (!row?.events?.filter((ev) => ev.length)?.length)
            return row; // skip computation if there are no cols with events in this row
        // misc. functions
        const overlaps = (e1, e2) => {
            return ((0, util_1.cachedMoment)(e1.event.data.period.end).isAfter(e2.event.data.period.start) &&
                (0, util_1.cachedMoment)(e1.event.data.period.start).isBefore(e2.event.data.period.end));
        };
        const earlierOf = (mom1, mom2) => {
            return (0, util_1.cachedMoment)(mom1).isBefore(mom2) ? mom1 : mom2;
        };
        const laterOf = (mom1, mom2) => {
            return (0, util_1.cachedMoment)(mom1).isAfter(mom2) ? mom1 : mom2;
        };
        // get row's events in a straight 1D array, sorted by start hour, for easier traversal
        const flatEvts = [];
        row.events.forEach((col, hr) => {
            col.forEach((evt, evtIdx) => {
                flatEvts.push({
                    event: evt,
                    colIdx: hr,
                    evtIdx,
                });
            });
        });
        // find the groups of overlapping events
        const groups = [];
        flatEvts.forEach((evt) => {
            let addedToGroup = false;
            groups.forEach((group, grpIdx) => {
                group.evts.forEach((evtInGrp) => {
                    if (overlaps(evt, evtInGrp) &&
                        !groups[grpIdx].evts.find((ev) => ev.event.data.id === evt.event.data.id)) {
                        groups[grpIdx].evts.push(evt);
                        groups[grpIdx].start = earlierOf(evt.event.data.period.start, groups[grpIdx].start);
                        groups[grpIdx].end = laterOf(evt.event.data.period.end, groups[grpIdx].end);
                        addedToGroup = true;
                    }
                });
            });
            if (!addedToGroup) {
                groups.push({
                    evts: [evt],
                    start: evt.event.data.period.start,
                    end: evt.event.data.period.end,
                });
            }
        });
        // set each shift's verticalShift to it's index in the group
        groups.forEach((group) => {
            const grpStartTimes = []; // however, if more events start at the same time, only the first one of them should have the verticalShift
            group.evts.forEach((evtInGrp, idxInGrp) => {
                const startTimeStr = (0, util_1.cachedMoment)(row.events[evtInGrp.colIdx][evtInGrp.evtIdx].data.period.start).format();
                // A compromise I'm willing to make
                const newData = Object.assign({}, row.events[evtInGrp.colIdx][evtInGrp.evtIdx].data);
                newData.verticalShift = idxInGrp;
                row.events[evtInGrp.colIdx][evtInGrp.evtIdx].data = newData;
                grpStartTimes.push(startTimeStr);
                // if (!grpStartTimes.includes(startTimeStr)) {
                //   const newData = Object.assign({}, row.events[evtInGrp.colIdx][evtInGrp.evtIdx].data)
                //   newData.verticalShift = idxInGrp
                //   row.events[evtInGrp.colIdx][evtInGrp.evtIdx].data = newData
                //   grpStartTimes.push(startTimeStr)
                // } else {
                //   // console.log('skipping', row.events[evtInGrp.colIdx][evtInGrp.evtIdx].data)
                //   const newData = Object.assign({}, row.events[evtInGrp.colIdx][evtInGrp.evtIdx].data)
                //   newData.verticalShift = 0
                //   row.events[evtInGrp.colIdx][evtInGrp.evtIdx].data = newData
                //   grpStartTimes.push(startTimeStr)
                // }
            });
        });
        return row;
    }
    render() {
        let row = this.props.row;
        // console.log('ROW PROPS', this.props.row)
        const isHighlighted = this.props.calendarSearch?.results.find((r) => r.id === row.employee);
        if (this.props.notVisible) {
            return (react_1.default.createElement("div", { className: 'ds-c-row ' + (isHighlighted ? 'is-highlighted' : ''), style: {
                    minHeight: this.props.computedRowHeight
                        ? this.props.computedRowHeight.toString() + 'px'
                        : undefined,
                } }));
        }
        const { idx, calendar } = this.props;
        if (calendar.view === 'day') {
            row = Object.assign({}, this._getDayRowWithoutOverlapping(row));
        }
        const res = this.getRowHTML(row, idx, isHighlighted);
        return res;
    }
}
exports.default = (0, connect_1.default)((0, use_modal_hoc_1.withUseModalHOC)(Row));
